import React from 'react';
import {Redirect, Route, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';

import {isLoggedIn, isLoggedInUser} from '../utils/auth';

function ProtectedAdminRoute({component: Component, ...rest}) {
    const {auth} = rest;
    const location = useLocation();

    const isAuthorized = isLoggedInUser(auth);
    const pathname = location.pathname;

    return (
        <Route {...rest} render={
            props => {
                if (pathname === '/backoffice/login') {
                    if (isAuthorized) {
                        return <Redirect to={
                            {
                                pathname: '/backoffice/orders',
                                state: {
                                    from: props.location
                                }
                            }
                        }/>;
                    } else return <Component {...rest} {...props} />;
                } else if (isAuthorized) {
                    return <Component {...rest} {...props} />;
                } else {
                    return <Redirect to={
                        {
                            pathname: '/backoffice/login',
                            state: {
                                from: props.location
                            }
                        }
                    }/>;
                }
            }
        }/>
    );
}

const mapStateToProps = state => ({auth: state.auth});

export default connect(mapStateToProps, null)(ProtectedAdminRoute);
